module.exports = __webpack_public_path__ + "img/fashion_78.a037db1a.jpg";